var exports = {
  "mU": "footnoteInlineLink__Ye3C2o",
  "PG": "sizeSmall__1IVAoR",
  "Pu": "sizeLarge__C1TAgd",
};

module.exports = exports;
